import { containsFilter, type ColumnFilter } from '../api/queryParams';
import type { VisibilityScoreFilter } from './execution-filters';

export interface TopicFiltersState {
  search: string;
  visibility: VisibilityScoreFilter;
}

export const DEFAULT_TOPIC_FILTERS: TopicFiltersState = {
  search: '',
  visibility: 'all',
};

/** Topics table filters for `POST /projects/:id/topics/list` (`search` = topic or top-brand name). */
export function topicTableFilters(filters: TopicFiltersState): Record<string, ColumnFilter> {
  const result: Record<string, ColumnFilter> = {};
  const search = filters.search.trim();
  if (search) result.search = containsFilter(search);
  if (filters.visibility !== 'all') {
    result.visibility = {
      filterModes: [{ mode: 'inrange', value: filters.visibility.split('-').map(Number) }],
      operator: 'and',
    };
  }
  return result;
}
